/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const DiscountDetailPage = lazyLoad(
  () => import('./index'),
  module => module.DiscountDetailPage
);
